import { IconDocument16, IconClose16, IconReload16 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatFileLoader.css';

type TChatFileLoader = {
  src: string | null;
  isOutcoming: boolean;
  isLoading?: boolean;
  withCancel?: boolean;
  withSave?: boolean;
  withReload?: boolean;
  withFileIcon?: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  onReload?: () => void;
};

export const ChatFileLoader: React.FC<TChatFileLoader> = ({
  src,
  isOutcoming,
  isLoading,
  withCancel,
  withSave,
  withReload,
  withFileIcon,
  onCancel,
  onSave,
  onReload,
}) => {
  return (
    <div className={styles['container']} data-name="ChatFileLoader">
      <div
        className={classNames(styles['circle'], isLoading && styles['loader'], !isOutcoming && styles['incoming'])}
      />
      {withCancel && onCancel && (
        <button className={styles['button']} onClick={onCancel}>
          <IconClose16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </button>
      )}
      {withSave && src && (
        <a href={src} className={styles['button']} onClick={onSave} target="_blank" data-name="ChatFileLoader_save">
          <IconDocument16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </a>
      )}
      {withReload && onReload && (
        <button className={styles['button']} onClick={onReload}>
          <IconReload16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </button>
      )}
      {withFileIcon && !withSave && (
        <div className={styles['button']}>
          <IconDocument16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </div>
      )}
    </div>
  );
};
